import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const DisciplinaCard = ({ disciplina }) => {
  // Verifica se disciplina existe antes de tentar acessar suas propriedades
  if (!disciplina) {
    return null; // ou você pode retornar um componente de fallback
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div">
          {disciplina.nome || 'Nome não disponível'}
        </Typography>
        <Typography color="text.secondary">
          Carga Horária: {disciplina.cargaHoraria || 'N/A'} horas
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {disciplina.descricao 
            ? `${disciplina.descricao.substring(0, 100)}...` 
            : 'Descrição não disponível'}
        </Typography>
        <Button 
          component={Link} 
          to={`/disciplinas/${disciplina.id}`} 
          variant="contained" 
          color="primary" 
          sx={{ mt: 2 }}
        >
          Ver Detalhes
        </Button>
      </CardContent>
    </Card>
  );
};

DisciplinaCard.propTypes = {
  disciplina: PropTypes.shape({
    nome: PropTypes.string.isRequired,
    cargaHoraria: PropTypes.number,
    descricao: PropTypes.string,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default DisciplinaCard;
